import * as ambassadorWixDataV2Backup from './data-v2-backup-backups.http.js';
import * as ambassadorWixDataV2BackupTypes from './data-v2-backup-backups.types.js';
import * as ambassadorWixDataV2BackupUniversalTypes from './data-v2-backup-backups.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createBackup(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixDataV2BackupUniversalTypes.CreateBackupRequest,
  ambassadorWixDataV2BackupTypes.CreateBackupRequest,
  ambassadorWixDataV2BackupUniversalTypes.CreateBackupResponse,
  ambassadorWixDataV2BackupTypes.CreateBackupResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixDataV2Backup.createBackup(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/backups',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listBackups(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixDataV2BackupUniversalTypes.ListBackupsRequest,
  ambassadorWixDataV2BackupTypes.ListBackupsRequest,
  ambassadorWixDataV2BackupUniversalTypes.ListBackupsResponse,
  ambassadorWixDataV2BackupTypes.ListBackupsResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixDataV2Backup.listBackups(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/backups',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function restoreBackup(): __PublicMethodMetaInfo<
  'POST',
  { backupId: string },
  ambassadorWixDataV2BackupUniversalTypes.RestoreBackupRequest,
  ambassadorWixDataV2BackupTypes.RestoreBackupRequest,
  ambassadorWixDataV2BackupUniversalTypes.RestoreBackupResponse,
  ambassadorWixDataV2BackupTypes.RestoreBackupResponse
> {
  const payload = { backupId: ':backupId' } as any;

  const getRequestOptions = ambassadorWixDataV2Backup.restoreBackup(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/backups/{backupId}/restore',
    pathParams: { backupId: 'backupId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function restorePartialBackup(): __PublicMethodMetaInfo<
  'POST',
  { backupId: string },
  ambassadorWixDataV2BackupUniversalTypes.RestorePartialBackupRequest,
  ambassadorWixDataV2BackupTypes.RestorePartialBackupRequest,
  ambassadorWixDataV2BackupUniversalTypes.RestorePartialBackupResponse,
  ambassadorWixDataV2BackupTypes.RestorePartialBackupResponse
> {
  const payload = { backupId: ':backupId' } as any;

  const getRequestOptions =
    ambassadorWixDataV2Backup.restorePartialBackup(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/backups/{backupId}/partial-restore',
    pathParams: { backupId: 'backupId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listRestorations(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixDataV2BackupUniversalTypes.ListRestorationsRequest,
  ambassadorWixDataV2BackupTypes.ListRestorationsRequest,
  ambassadorWixDataV2BackupUniversalTypes.ListRestorationsResponse,
  ambassadorWixDataV2BackupTypes.ListRestorationsResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixDataV2Backup.listRestorations(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/backups/restorations',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteBackup(): __PublicMethodMetaInfo<
  'DELETE',
  { backupId: string },
  ambassadorWixDataV2BackupUniversalTypes.DeleteBackupRequest,
  ambassadorWixDataV2BackupTypes.DeleteBackupRequest,
  ambassadorWixDataV2BackupUniversalTypes.DeleteBackupResponse,
  ambassadorWixDataV2BackupTypes.DeleteBackupResponse
> {
  const payload = { backupId: ':backupId' } as any;

  const getRequestOptions = ambassadorWixDataV2Backup.deleteBackup(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v2/backups/{backupId}',
    pathParams: { backupId: 'backupId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Backup as BackupOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  Collection as CollectionOriginal,
  BackupStateChanged as BackupStateChangedOriginal,
  RestorationStateChanged as RestorationStateChangedOriginal,
  Restoration as RestorationOriginal,
  RestorationStatus as RestorationStatusOriginal,
  RestorationStatusWithLiterals as RestorationStatusWithLiteralsOriginal,
  RestorationCollection as RestorationCollectionOriginal,
  RestoreDestination as RestoreDestinationOriginal,
  CreateBackupRequest as CreateBackupRequestOriginal,
  CreateBackupResponse as CreateBackupResponseOriginal,
  ListBackupsRequest as ListBackupsRequestOriginal,
  Paging as PagingOriginal,
  ListBackupsResponse as ListBackupsResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  RestoreBackupRequest as RestoreBackupRequestOriginal,
  RestoreBackupResponse as RestoreBackupResponseOriginal,
  RestorePartialBackupRequest as RestorePartialBackupRequestOriginal,
  RestorePartialBackupResponse as RestorePartialBackupResponseOriginal,
  ListRestorationsRequest as ListRestorationsRequestOriginal,
  ListRestorationsResponse as ListRestorationsResponseOriginal,
  DeleteBackupRequest as DeleteBackupRequestOriginal,
  DeleteBackupResponse as DeleteBackupResponseOriginal,
  CancelBackupRequest as CancelBackupRequestOriginal,
  CancelBackupResponse as CancelBackupResponseOriginal,
  MigrateNamespaceRequest as MigrateNamespaceRequestOriginal,
  MigrateNamespaceResponse as MigrateNamespaceResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  DisableInstanceRequest as DisableInstanceRequestOriginal,
  Empty as EmptyOriginal,
  EnableInstanceRequest as EnableInstanceRequestOriginal,
  DeleteAllRequest as DeleteAllRequestOriginal,
  GetBackupMetadataRequest as GetBackupMetadataRequestOriginal,
  GetBackupMetadataResponse as GetBackupMetadataResponseOriginal,
  RebuildRequest as RebuildRequestOriginal,
  MoveRequest as MoveRequestOriginal,
  RemoveDeletedRequest as RemoveDeletedRequestOriginal,
  FailRestorationRequest as FailRestorationRequestOriginal,
  TakeBackupRequest as TakeBackupRequestOriginal,
  UpdateBackupMetadataRequest as UpdateBackupMetadataRequestOriginal,
} from './data-v2-backup-backups.types.js';
